/* Petal Keeps: show USD-based amounts in the shopper's currency.
   The shop currency is USD. Shopify converts prices with Shopify.currency.rate and rounds them up to .99,
   and converts the free-shipping threshold with the same rate. Liquid can't read that rate, so the theme
   renders an estimate and this script swaps in the exact figure.
   - [data-pk-usd="5000"]                 -> whole-unit amount in local currency, e.g. "A$77" (rounded up)
   - [data-pk-usd="3999"][data-pk-round="99"] -> local price rounded up to .99, keeping the theme's money format
   - .cart-progress[data-pk-goal]         -> free-shipping bar recalculated with the exact rate
   It also places the country/currency pickers (rendered into <template id="pk-loc-header|pk-loc-drawer">
   by the "Currency tools" Custom Liquid section in the footer group) into the header icons and the mobile menu. */
(function () {
  if (window.pkCurrencyInit) return;
  window.pkCurrencyInit = true;

  function cur() { return (window.Shopify && window.Shopify.currency) || {}; }
  function rate() { var r = parseFloat(cur().rate); return r > 0 ? r : 1; }
  function code() { return cur().active || 'USD'; }
  function isBase() { return rate() === 1; }
  function swapNumber(text, cents) {
    var n = (Math.max(0, cents) / 100).toFixed(2).replace(/\.00$/, '');
    return text.replace(/\d[\d,]*(\.\d+)?/, n);
  }
  function wholeMoney(cents) {
    try {
      return new Intl.NumberFormat('en', { style: 'currency', currency: code(), minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.ceil(cents / 100));
    } catch (e) { return null; }
  }

  function fixMoney() {
    var els = document.querySelectorAll('[data-pk-usd]:not([data-pk-done])');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.setAttribute('data-pk-done', '1');
      var usd = parseInt(el.getAttribute('data-pk-usd'), 10);
      if (!usd) continue;
      var cents = usd * rate();
      if (el.getAttribute('data-pk-round') === '99') {
        if (!isBase()) el.textContent = swapNumber(el.textContent, Math.ceil((Math.round(cents) - 99) / 100) * 100 + 99);
      } else {
        var s = wholeMoney(cents);
        if (s) el.textContent = s;
      }
    }
  }

  function fixBars() {
    var els = document.querySelectorAll('.cart-progress[data-pk-goal]:not([data-pk-done])');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.setAttribute('data-pk-done', '1');
      var goal = Math.ceil(parseInt(el.getAttribute('data-pk-goal'), 10) * rate());
      var sub = parseInt(el.getAttribute('data-pk-subtotal'), 10) || 0;
      if (!(goal > 0)) continue;
      var reached = sub >= goal;
      var bar = el.querySelector('.cart-progress__bar__progress');
      if (bar) bar.style.width = (reached ? 100 : Math.max(0, (sub / goal) * 100)) + '%';
      var p = el.querySelector('[data-pk-progress]');
      var s = el.querySelector('[data-pk-success]');
      if (p) p.style.display = reached ? 'none' : '';
      if (s) s.style.display = reached ? '' : 'none';
      var amt = el.querySelector('[data-pk-amount]');
      if (amt && !reached) amt.textContent = swapNumber(amt.textContent, goal - sub);
    }
  }

  function placePickers() {
    var icons = document.querySelector('.header__icons');
    var th = document.getElementById('pk-loc-header');
    if (icons && th && !icons.querySelector('.pk-loc')) {
      var slot = document.createElement('div');
      slot.className = 'small-hide pk-loc-slot';
      slot.appendChild(th.content.cloneNode(true));
      var before = icons.querySelector('.header__icon--account') || icons.querySelector('#cart-icon-bubble');
      icons.insertBefore(slot, before || null);
    }
    var drawer = document.querySelector('.menu-drawer__utility-links');
    var td = document.getElementById('pk-loc-drawer');
    if (drawer && td && !drawer.querySelector('.pk-loc')) {
      drawer.insertBefore(td.content.cloneNode(true), drawer.firstChild);
    }
  }

  function run() { placePickers(); fixMoney(); fixBars(); }
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; run(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  if (window.MutationObserver) new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
